export default "__VITE_ASSET__DWYoVp5D__"